import httpClient from "../../../../api/httpClient";

// The uploaded file is small (a few hundred rows at most) and JWT/CORS-safe reasons make a
// stateless design simpler than caching parsed rows server-side across 3 prod instances with no
// shared session store today -- so every step re-sends the file. See bulkupload backend package
// for the generic (entity-agnostic) preview/dry-run/execute contract this calls.

const jsonPart = (value) => new Blob([JSON.stringify(value)], { type: "application/json" });

export const bulkUpdateApi = {
  preview: (entityType, file, sheetName) => {
    const formData = new FormData();
    formData.append("file", file);
    if (sheetName) formData.append("sheetName", sheetName);
    return httpClient
      .post(
        `${process.env.REACT_APP_API_BASE_URL}/api/bulk-upload/${entityType}/preview`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      )
      .then((r) => r.data);
  },

  dryRun: (entityType, file, sheetName, mappings) => {
    const formData = new FormData();
    formData.append("file", file);
    if (sheetName) formData.append("sheetName", sheetName);
    formData.append("mappings", jsonPart(mappings));
    return httpClient
      .post(
        `${process.env.REACT_APP_API_BASE_URL}/api/bulk-upload/${entityType}/dry-run`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      )
      .then((r) => r.data);
  },

  execute: (entityType, file, sheetName, mappings, decisions) => {
    const formData = new FormData();
    formData.append("file", file);
    if (sheetName) formData.append("sheetName", sheetName);
    formData.append("mappings", jsonPart(mappings));
    formData.append("decisions", jsonPart(decisions));
    return httpClient
      .post(
        `${process.env.REACT_APP_API_BASE_URL}/api/bulk-upload/${entityType}/execute`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      )
      .then((r) => r.data);
  },
};
